module.exports = __webpack_public_path__ + "img/9cb6617a86689a67510357ae8b104ad6.png";